import { render } from "./SimpleSearchResultRow.vue?vue&type=template&id=9a8521aa"
import script from "./SimpleSearchResultRow.vue?vue&type=script&lang=js"
export * from "./SimpleSearchResultRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__